__turbopack_context__.v({
  "scrollToTop": "ScrollToTopButton-module__VF2H_G__scrollToTop",
  "visible": "ScrollToTopButton-module__VF2H_G__visible",
});
